module.exports = __webpack_public_path__ + "static/media/cldc2014_program.9d191ce5.pdf";